import { useLogin, useLogout, useSession } from '../api/use-session.js';

/**
 * Composite auth hook — thin wrapper that exposes `{ user,
 * isAuthenticated, isLoading, login, logout }` built from the three
 * react-query hooks.
 */
export function useAuth() {
  const session = useSession();
  const login = useLogin();
  const logout = useLogout();

  return {
    user: session.data ?? null,
    isAuthenticated: Boolean(session.data),
    isLoading: session.isPending,
    login: login.mutateAsync,
    logout: logout.mutateAsync,
  };
}
